import React, { useState, useEffect } from 'react';
import { Typography, TextField, FormControl, Dialog, Divider, Button, } from '@mui/material';
import {
  FormStyled, DivSubmitButtons, DivFormTitle
} from '../../../Admin/Forms/styles';
import { uniqueId } from 'lodash';

interface IAccountableTenant {
  _id: string;
  name: string;
  email: string;
  role: string;
  phone: string;
}

interface IProps {
  onClose: CallableFunction;
  onSubmit: (body: IAccountableTenant) => void;
  open: boolean;
  accountable?: IAccountableTenant;
}

const ModalAccountable = ({ open, onSubmit, accountable, onClose }: IProps) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [role, setRole] = useState('');

  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);

  useEffect(() => {
    if (open) {
      setName(accountable?.name || '');
      setRole(accountable?.role || '');
      setPhone(accountable?.phone || '');
      setEmail(accountable?.email || '');

      setNameError(false);
      setEmailError(false);
    }
  }, [open])

  const handleSubmit = async () => {
    let hasError = false;

    if (name === '') {
      hasError = true;
      setNameError(true);
    }

    if (email === '') {
      hasError = true;
      setEmailError(true);
    }

    if (hasError) return

    const body = {
      _id: accountable ? accountable._id : uniqueId(),
      email,
      name,
      phone,
      role
    };

    onSubmit(body);
    onClose();
  }

  return (
    <Dialog
      maxWidth='sm'
      fullWidth
      scroll='body'
      open={open}
      onClose={() => onClose()}
    >
      <FormStyled onSubmit={handleSubmit} style={styles.opacityContainer}>
        <DivFormTitle>
          <Typography variant='h6'>{accountable ? 'Editar' : 'Adicioanar'} responsável</Typography>
        </DivFormTitle>
        <Divider />
        <FormControl variant="standard" fullWidth margin='normal' required>
          <TextField
            variant="standard"
            label='Nome'
            name='name'
            onChange={event => { setNameError(false); setName(event.target.value); }}
            value={name}
            margin='normal'
            error={nameError}
            helperText="Preencha o nome do responsável"
          />
          <TextField
            variant="standard"
            label='Telefone'
            name='phone'
            onChange={event => { setPhone(event.target.value); }}
            value={phone}
            margin='normal'
            error={false}
            helperText="Preencha o telefone do responsável"
          />
          <TextField
            variant="standard"
            label='Email'
            name='email'
            onChange={event => { setEmailError(false); setEmail(event.target.value); }}
            value={email}
            margin='normal'
            error={emailError}
            helperText="Preencha o email do responsável"
          />
          <TextField
            variant="standard"
            label='Cargo'
            name='role'
            onChange={event => { setRole(event.target.value); }}
            value={role}
            margin='normal'
            error={false}
            helperText="Preencha o cargo do responsável"
          />
        </FormControl>
        <DivSubmitButtons>
          <Button sx={{color: '#D32F2F', marginRight: '10px' }} onClick={() => onClose()}>
            Cancelar
          </Button>
          <Button sx={{color: '#fff', background: '#4CAF50' }} onClick={() => handleSubmit()}>
            {accountable ? 'Salvar' : 'Adicionar'}
          </Button>
        </DivSubmitButtons>
      </FormStyled>
    </Dialog>
  );
}

export default ModalAccountable;

const styles = {
  container: {
    padding: '10px',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  print: {
    marginRight: 5,
  },
  contentContainer: {
    margin: '30px 0',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  opacityContainer: {
    position: 'relative'
  },
  fileError: {
    color: '#f44336'
  },
  question: {
    marginTop: 20,
  },
  sectionTitleContainer: {
    display: 'flex',
    marginTop: 20,
  },
  avatarContainer: {
    display: 'flex',
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar: {
    width: 150,
    height: 150,
    marginTop: 20,
  },
  avatarButton: {
    margin: 5,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageInput: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 10,
  },
  buttonEditImage: {
    // margin: '-58px 0 0 -146px',
    margin: '10px 0',
  }
}
